// структура элементов для добавления информации о новом питомце для админа
<template>
  <v-form>
    <v-container fluid>
      
      <v-flex xs12 sm12 md12 >
        <v-card elevation="0">
          <v-card-title class="blue-grey--text text-md-h4 text-sm-h5 text-xs-h6 font-weight-bold textWordBreak">
           Редактировать событие
          </v-card-title>
        </v-card>
      </v-flex>

      <v-alert
        color="#2A3B4D"
        dark
        dense
        dismissible
        close-text="Закрыть"
        align="left"
      >
        Вы можете загрузить 3 фотографии, размер каждой не должен превышать 3 мегабайта. 
        <br> При фотографировании телефоном желательно установить в настройках камеры размер фотографий 1:1
      </v-alert>

    <v-card  class="my-5" elevation='0'>
        <v-card-actions>
        <handy-uploader
          :documentAttachment.sync="handyAttachments"
          :fileUploaderType="'thumbnail'"
          :fileAccept="'image/png,image/gif,image/jpeg,image/webp'"
          :maxFileSize="3000"
          :imageCompressor="true"
          :imageCompressLevel="0.35"
          :maxFileCount="3"
          :badgeCounter="false"
          :thumb="false"
          :changeFileName="true"
          :addFileDescription="true"
          :addFileTag="false"
        >
        </handy-uploader>
      </v-card-actions>
    </v-card>

    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="4"
      >
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :return-value.sync="date"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date"
              label="Дата публикации"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            no-title
            scrollable
          >
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="menu = false"
            >
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.menu.save(date)"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-row>


       <v-row class="ma-1 ">
        <v-col
          v-for="(img, k) in images"
          :key="k"
          class="d-flex child-flex col-sm-10 offset-sm-1 col-md-6 offset-md-0 col-lg-4 col-xl-4 "
        >
          <v-img
            :src="img"
            class="white"
            max-height='400'
          >
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-col>
      </v-row>

      <v-text-field
        v-model="newsTitle"
        clearable
        clear-icon="mdi-close-circle"
        label="Тема"
        type="text"
      ></v-text-field>

<!-- <QuillEditorSettings :news="news" class="mt-5 mb-7"></QuillEditorSettings> -->

      <quill-editor
        :content="content"
        :options="editorOption"
        @change="onEditorChange($event)"
      />




      <v-progress-linear
        v-if="progress > 0"
        v-model="progress"
        height="25"
        class="my-2"
      >
      <strong>{{ Math.ceil(progress) }}%</strong>
      </v-progress-linear>    

      <v-row>
        <v-btn 
          :to="{name:'mercy'}"
          class="mx-4 mt-3 pr-2 text-subtitle-1"
          color="error"
          width="152px"
          dark
        >Отменить<v-icon size="25" class="ml-2 ">mdi mdi-close</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn 
          @click="loadNewImage"
          class="mx-4 mt-3 pr-2  text-subtitle-1"
          color="success"
          width="152px"
          dark
          >Добавить<v-icon size="25" class="ml-2 pb-1">mdi mdi-check</v-icon>
        </v-btn>
      </v-row>

    </v-container>
  </v-form>
</template>

<script>
import handyUploader from "handy-uploader/src/components/handyUploader";
import firebase from "firebase/app";
import Vue from "vue";
// import QuillEditorSettings from './QuillEditorSettings'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'

export default {
  data() {
    return {
      id: this.news.id,
      newsTitle: this.news.newsTitle,
      images: this.news.images,
      // emojiText: this.news.emojiText,
      imgIndexArr: this.news.imgIndexArr,
      newImgIndexArr: [],
      handyAttachments: [],
      imgfile: [],
      progress: 0,
      imagesObj: {},
      text: '',
      checkNewIMG: false,
      delProcessCount: 0,
      oldImgArr: undefined,
      imgNamesArr: [],
      formatedText: '',
      mainImgIndex: '',
      changeEmojiText: false,
      date: this.news.date,
      menu: false,

      content: this.news.emojiText,
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
            [{ 'header': 1 }, { 'header': 2 } ],               // custom button values
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
            // [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
            [{ 'font': [] }],
            ['link'],
            ['clean']          
          ]
        },
        theme: 'snow',
      }
    }
  },

created () {
    return this.$store.dispatch('DELETE_QUILL_HTML');
  },


methods: {
  onEditorChange({ html }) {
    // console.log('editor change!', quill, html, text)
    // this.content = html
    this.changeEmojiText = true;
    this.$store.dispatch('UPDATE_QUILL_HTML', html);
  },

    // загрузка нового изображения в БД
  async loadNewImage() {
      let me = this;
      let arr = [];
      // let imgNamesArr = [];
      let imgObject;
      let newImageName = "";
      arr = this.handyAttachments;

    // проверка на изменение фото
    if (arr.length != 0) {
      
      // delete old photos
      this.deleteNewsPhoto()


      for (let index = 0; index < arr.length; index++) {
        this.imgfile = arr[index];
        
        // // проверка на изменение фото
        // if (this.imgfile != undefined) {
          Object.keys(this.imgfile).forEach((element)  => {  
            imgObject = this.imgfile[element].base64;
            // имя нового изображения
            newImageName = this.imgfile[element].name;
            this.imgNamesArr.push(newImageName);

            // Create the file metadata
            var metadata = {
              contentType: "image/jpeg",
            };

            // Base64 formatted string
            var message = imgObject;
            var ref = Vue.$storageRef.child("newsIMG/" + newImageName + this.id);
            // Upload file and metadata to the object ''images/' + newImageName'
            var uploadTask = ref.putString(message, "base64", metadata);

            // Listen for state changes, errors, and completion of the upload.
            uploadTask.on(
              firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
              function (snapshot) {
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                me.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                // console.log("Upload is " + me.progress + "% done");
                switch (snapshot.state) {
                  case firebase.storage.TaskState.PAUSED: // or 'paused'
                    // console.log("Upload is paused");
                    break;
                  case firebase.storage.TaskState.RUNNING: // or 'running'
                    // console.log("Upload is running");
                    break;
                }
              },
              function (error) {
                // A full list of error codes is available at
                // https://firebase.google.com/docs/storage/web/handle-errors
                switch (error.code) {
                  case "storage/unauthorized":
                    // User doesn't have permission to access the object
                    break;

                  case "storage/canceled":
                    // User canceled the upload
                    break;

                  case "storage/unknown":
                    // Unknown error occurred, inspect error.serverResponse
                    break;
                }
              },
             async function () {
                // Upload completed successfully, now we can get the download URL
                uploadTask.snapshot.ref
                  .getDownloadURL()
                  .then(function (downloadURL) {
                    // me.newImageURL = downloadURL;
                    // me.imagesObj[me.imgNamesArr[index] + me.id] = downloadURL;
                    let imgIndex = me.imgNamesArr[index] + me.id;
                    me.mainImgIndex = imgIndex;
                    me.imagesObj[imgIndex] = downloadURL;
                    me.newImgIndexArr.push(imgIndex);
                  })
                  .then(await function () {
                    me.checkNewIMG = true;
                    me.loadNewInfo();
                  });
              }
            );
           
          });
        // }
      }
    } else {
        me.checkNewIMG = false;
        me.loadNewInfo();
      }
   
  },

    // удаление старой фото из базы
  deleteNewsPhoto() {
    Object.keys(this.imgIndexArr).forEach(key => {
      let dellmgIndex = this.imgIndexArr[key];
      let ref = Vue.$storageRef.child("newsIMG/" + dellmgIndex);
      // Delete photos
      ref.delete()
        .then(() => {
          console.log("Photos deleted successfully");
        })
        .catch((error) => {
          console.log("No such image!", error);
        })
    });

  },
    
  // инициализация переменной редактируемого html текста
  loadEmojiText(){
    if (this.changeEmojiText) {
      this.formatedText = this.$store.getters.getQuillText;
    } else {
      this.formatedText = this.news.emojiText;
    }
    
    // this.content =  this.formatedText;
  },
   
  // загрузка нового описания в БД
 async loadNewInfo() {
     await this.loadEmojiText()

    // удаление старой фото из базы при изменении картинки 
    if (this.checkNewIMG) {
      // console.log('-----');
      // const formatedText = this.$store.getters.getQuillText;
      // console.log(formatedText);
      const db1 = Vue.$db.collection("news").doc(this.id);
      db1.update({
        newsTitle: this.newsTitle,
        id: this.id,
        images: this.imagesObj,
        mainImg: this.imagesObj[this.mainImgIndex],
        imgIndexArr: this.newImgIndexArr,
        // emojiText: this.emojiText,
        emojiText: this.formatedText,
        userDate: this.date,
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
      })
      .then(() => {
        this.$router.push("/mercy").catch(()=>{});
      })
      .catch((error) => {
          console.error("Error adding document: ", error);
      });
    } else {
      // console.log('+++++');
      // const formatedText = this.$store.getters.getQuillText;
      // console.log(formatedText);
      const db1 = Vue.$db.collection("news").doc(this.id);
      db1.update({
        newsTitle: this.newsTitle,
        id: this.id,
        // images: this.imagesObj,
        // emojiText: this.emojiText,
        emojiText: this.formatedText,
        userDate: this.date,
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
      })
      .then(() => {
        this.$router.push("/mercy").catch(()=>{});
      })
      .catch((error) => {
          console.error("Error adding document: ", error);
      });
    }
    
  },

},


  components: {
    handyUploader,
    // QuillEditorSettings
    quillEditor
  },

  props: {
    news: {
      type: Object,
      required: true,
    },
  },

};
</script>
